(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-included-components]').forEach(function (root) {
    var items = root.querySelectorAll('[data-accordion-item]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var panel = item.querySelector('[data-accordion-panel]');

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        items.forEach(function (otherItem) {
          var otherTrigger = otherItem.querySelector('[data-accordion-trigger]');
          var otherPanel = otherItem.querySelector('[data-accordion-panel]');
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherPanel.setAttribute('data-expanded', 'false');
        });

        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          panel.setAttribute('data-expanded', 'true');
        }
      });
    });

    // Each group ("What's included", "Specification", "Features", etc.)
    // has its own independent toggle — expanding/collapsing one has no
    // effect on the others.
    var groupToggles = root.querySelectorAll('[data-group-toggle]');
    groupToggles.forEach(function (toggle) {
      var body = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!body) return;

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        body.style.display = isOpen ? 'none' : '';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-accordion2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fa-accordion]').forEach(function (root) {
    var items = root.querySelectorAll('[data-fa-item]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-fa-trigger]');
      var panel = item.querySelector('[data-fa-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        items.forEach(function (otherItem) {
          var otherTrigger = otherItem.querySelector('[data-fa-trigger]');
          var otherPanel = otherItem.querySelector('[data-fa-panel]');
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherPanel.setAttribute('data-fa-expanded', 'false');
        });

        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          panel.setAttribute('data-fa-expanded', 'true');
        }
      });
    });

    var toggle = root.querySelector('[data-fa-toggle]');
    var body = root.querySelector('[data-fa-body]');
    if (toggle && body) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        body.style.display = isOpen ? 'none' : '';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-compatibleadd-ons"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pager]').forEach(function (pager) {
    var pages = Array.from(pager.querySelectorAll('[data-page]'));
    var nav = pager.querySelector('[data-pager-nav]');
    if (!nav || pages.length < 2) return;

    var prevBtn = nav.querySelector('[data-pager-prev]');
    var nextBtn = nav.querySelector('[data-pager-next]');
    var dots = Array.from(nav.querySelectorAll('[data-pager-dot]'));
    var currentPage = 0;

    function showPage(index) {
      currentPage = index;
      pages.forEach(function (page, i) {
        if (i === index) {
          page.removeAttribute('hidden');
        } else {
          page.setAttribute('hidden', '');
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === pages.length - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentPage > 0) showPage(currentPage - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentPage < pages.length - 1) showPage(currentPage + 1);
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        showPage(i);
      });
    });

    showPage(0);
  });

  document.querySelectorAll('[data-mobile-dots]').forEach(function (dotsContainer) {
    var pager = dotsContainer.closest('[data-pager]');
    if (!pager) return;

    var mql = window.matchMedia('(max-width: 749px)');
    var built = false;
    var cards = [];
    var perView = 2;
    var dotButtons = [];

    function buildDots() {
      if (built) return;
      cards = Array.from(pager.querySelectorAll('.product-card'));
      if (cards.length <= perView) return;

      var dotCount = Math.ceil(cards.length / perView);
      dotsContainer.innerHTML = '';
      dotButtons = [];
      for (var i = 0; i < dotCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'complementary-products__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to item group ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            var targetCard = cards[index * perView];
            if (targetCard) {
              targetCard.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            }
          });
        })(i);
        dotsContainer.appendChild(dot);
        dotButtons.push(dot);
      }
      built = true;
    }

    function updateActiveDot() {
      if (!built || !cards.length) return;
      var scrollLeft = pager.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;
      cards.forEach(function (card, i) {
        var distance = Math.abs(card.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      var activeDotIndex = Math.round(closestIndex / perView);
      dotButtons.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeDotIndex);
      });
    }

    var scrollTimeout;
    pager.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 80);
    });

    function handleViewportChange() {
      if (mql.matches) {
        buildDots();
      }
    }

    handleViewportChange();
    mql.addEventListener('change', handleViewportChange);
  });

  } catch(e) { console.error(e); }
})();
})();
